import ApplicationSerializer from 'teacher-ui-client/serializers/application'

export default class SchoolRolloverSerializer extends ApplicationSerializer {
  attrs = {
    subscriptionType: 'product',
  }

  serialize(...args: Parameters<ApplicationSerializer['serialize']>) {
    const payload = super.serialize(...args) as object & { data: { relationships?: unknown } }
    delete payload.data.relationships
    return payload
  }

  keyForRelationship(key: string, typeClass: string, method: string) {
    const relationshipName = key === 'rolloverOwner' ? 'user' : key
    return super.keyForRelationship(relationshipName, typeClass, method)
  }

  modelNameFromPayloadKey(key: string) {
    return super.modelNameFromPayloadKey(key === 'teachers' ? 'rollover-owner' : key)
  }

  payloadKeyFromModelName(modelName: string) {
    const payloadKeyName = modelName === 'rollover-owner' ? 'teachers' : modelName
    return super.payloadKeyFromModelName(payloadKeyName)
  }

  serializeAttribute(...args: Parameters<ApplicationSerializer['serializeAttribute']>) {
    const [snapshot, _json, key] = args
    if (snapshot.changedAttributes()[key]) {
      super.serializeAttribute(...args)
    }
  }
}
